import { useEffect, useState } from "react";
import { Text } from "react-native";
import { useUISlice } from "@/models/useUISlice";
import ModalContainer from "@/ui/ModalContainer";
import Input from "@/ui/Input";
import { ms } from "@/ui/moderateScale";
import { useTranslation } from "react-i18next";
import { Colors } from "@/constants";
import PrimaryButton from "@/ui/PrimaryButton";

const AlertPromptSignIn = () => {
  const prompt = useUISlice((state) => state.alertPromptSignIn);
  const setPrompt = useUISlice((state) => state.setAlertPromptSignIn);
  const [text, setText] = useState("");
  const width = useUISlice((state) => state.device.width);
  const isMobile = useUISlice((state) => state.device.isMobile);
  const { t } = useTranslation();

  useEffect(() => {
    if (!prompt) return;

    setText(prompt.defaultValue || "");
  }, [prompt]);

  const _onPress = () => {
    prompt.button && prompt.button.onPress(text);
  };

  if (!prompt) return null;

  return (
    <ModalContainer
      title={prompt.title}
      subtitle={prompt.subtitle}
      onDismiss={() => setPrompt(undefined)}
      primaryButtonText={t("useAuth.signInButton")}
      onPrimaryButtonPress={_onPress}
      hideDismissIcon={prompt.hideDismissIcon}
      hideCancel
      statusBarBgColor={isMobile ? "#5c5c5c" : undefined}
      shouldPersistBackdropClick={prompt.shouldPersistBackdropClick}
      loading={prompt.loading}
      destructive={prompt.button && prompt.button.destructive}
      modalWidth={Math.min(width - ms(32), ms(400))}
    >
      {prompt.onAppleSignIn && (
        <PrimaryButton
          text={t("useAuth.signInWithApple")}
          onPress={prompt.onAppleSignIn}
          icon="apple"
          height={ms(48)}
          style={{
            borderRadius: ms(8),
            marginTop: ms(16),
            backgroundColor: Colors.black,
          }}
          iconStyle={{
            tintColor: Colors.white,
            width: ms(18),
            height: ms(18),
            marginTop: ms(0),
          }}
        />
      )}

      {prompt.onGoogleSignIn && (
        <PrimaryButton
          text={t("useAuth.signInWithGoogle")}
          onPress={prompt.onGoogleSignIn}
          icon="google"
          style={{
            marginTop: ms(16),
            borderRadius: ms(8),
            borderWidth: 1,
            backgroundColor: Colors.white,
            borderColor: Colors.borderColor,
            height: ms(48),
          }}
          textStyle={{ color: Colors.text }}
          iconStyle={{
            tintColor: undefined,
            width: ms(18),
            height: ms(18),
            marginTop: ms(0),
          }}
        />
      )}

      {(prompt.onGoogleSignIn || prompt.onAppleSignIn) && (
        <Text
          style={{
            marginTop: ms(16),
            textAlign: "center",
            marginVertical: ms(20),
            color: Colors.subtitle,
          }}
        >
          {t("useAuth.or").toUpperCase()}
        </Text>
      )}

      <Input
        disabled={prompt.loading}
        height={prompt.multiLine ? ms(220) : undefined}
        multiLine={prompt.multiLine}
        value={text}
        autoFocus
        placeholder={prompt.placeholder}
        onTextChange={(text) => setText(text)}
      />
    </ModalContainer>
  );
};

export default AlertPromptSignIn;
